import { dataViewTranslations } from '@adornis/data-view/default-translations.js';
import { fieldManagementTranslations } from '@adornis/field-management/default-translations.js';
import { filterTranslations } from '@adornis/filter/default-translations.js';
import { Language } from '@adornis/translation-core/languages.js';
import { EntityClass } from './enums/class-names.js';

export const translationDict = {
  ...dataViewTranslations,
  ...filterTranslations,
  filter: {
    ...filterTranslations.filter,
    incomplete: [' ', ' '],
  },
  ...fieldManagementTranslations,
  validation_non_optional: ['Dieses Feld darf nicht leer sein.'],
  validation_iban: ['Diese IBAN ist ungültig.'],
  validation_TIN: ['Die 11-stellige Steuer ID ist ungültig.'],
  validation_rentenVersicherungsNr: ['Ungültige Rentenversicherungsnummer.'],

  validation_birthday_12: ['Das Geburtsdatum muss mind. 12 Jahre in der Vergangenheit liegen.'],
  multipleValidationErrors: ['Es sind mehrere Fehler aufgetreten.'],
  validation_jobticket_past: ['Das Datum darf nicht in der Vegangenheit liegen'],
  validation_jobticket_order_date: ['Sie können das Ticket frühstens zum 9. des Vormonats bestellen.'],
  validation_jobticket_order_missing: ['Bitte geben Sie zuerst ein Bestelldatum an.'],
  validation_jobticket_cancel_past: ['Das Kündigungsdatum darf nicht in der Vergangenheit sein.'],
  validation_jobticket_cancel_before_order: ['Das Kündigungsdatum darf nicht vor dem Bestellungsdatum liegen.'],
  validation_jobticket_cancel_date: ['Sie können das Ticket frühstens zum 9. des Vormonats kündigen.'],

  debitornummer_non_optional: ['Es muss eine Debitorennummer für die Schule festgelegt werden.'],
  debitornummer_type_number: ['Die Debitorennummer muss vom Typ Zahl sein.'],
  debitornummer_3_digits: ['Die Debitorennummer muss 3 Ziffern lang sein.'],
  invalid_credentials: ['Die Email oder das Passwort sind nicht korrekt.'],
  ambiguous_login: ['Anmeldung nicht möglich. Bitte wenden Sie sich an die Administration.'],
  password_reset_ambiguous: [
    'Hier ist etwas schiefgelaufen. Bitte verwenden Sie zum Zurücksetzen Ihren Benutzernamen.',
  ],
  email_in_use: ['Diese Email wird bereits verwendet.'],
  username_in_use: ['Dieser Benutzername wird bereits verwendet.'],
  username_required: ['Es muss ein Benutzername angegeben werden.'],
  _class: {
    [EntityClass.URLAUB]: ['Urlaub'],
    [EntityClass.KRANKHEIT]: ['Krankheit'],
    [EntityClass.KIND_KRANK]: ['Kind krank'],
    [EntityClass.MUTTERSCHUTZ]: ['Mutterschutz'],
    [EntityClass.ELTERNZEIT]: ['Elternzeit'],
    [EntityClass.AN_SCHWERBEHINDERUNG]: ['Schwerbehinderung'],
    [EntityClass.SABBATICAL]: ['Sabbatical'],
    [EntityClass.ALTERSTEILZEIT]: ['Altersteilzeit'],
    [EntityClass.UNBEZAHLTER_URLAUB]: ['unbezahlter Urlaub'],
    [EntityClass.BESCHAEFTIGUNGSVERBOT]: ['Beschäftigungsverbot'],
    [EntityClass.FORTBILDUNG]: ['Fortbildung / Dienst an anderen Orten'],
    [EntityClass.DIENSTLICHE_BEURLAUBUNG]: ['Dienstliche Beurlaubung'],
    [EntityClass.KLASSENFAHRT]: ['Klassenfahrt'],
    [EntityClass.EXKURSION]: ['Exkursion'],
    [EntityClass.DIENST_AM_ANDEREN_ORT]: ['Dienst am anderen Ort'],
    [EntityClass.LEHRPROBE]: ['Lehrprobe'],
    [EntityClass.INTERNER_EINSATZ]: ['Interner Einsatz'],
    [EntityClass.SOZIALPRAKTIKUM]: ['Sozialpraktikum'],
    [EntityClass.FREIE_STUDIEN]: ['Freie Studien'],
    [EntityClass.ABITURPRUFUNGEN]: ['Abiturprüfungen'],
    [EntityClass.ELTERNZEIT_TEILZEIT]: ['Elternzeit Teilzeit'],
    [EntityClass.ALTERSTEILZEIT_AKTIV]: ['Altersteilzeit Aktiv'],
    [EntityClass.ALTERSTEILZEIT_PASSIV]: ['Altersteilzeit Passiv'],
    [EntityClass.VOLL_FREIGESTELLT_PFLEGE]: ['Pflegezeit mit vollständiger Freistellung'],
    [EntityClass.VOLLE_ERWERBSMINDERUNGS_RENTE]: ['Volle Erwerbsminderungsrente'],
    [EntityClass.GRUPPE]: ['Gruppe'],
    [EntityClass.SCHULE]: ['Schule'],
    [EntityClass.SCHULGRUPPE]: ['Klasse'],
    [EntityClass.KOSTENSTELLE]: ['Kostenstelle'],
    [EntityClass.SONDERURLAUB]: ['Sonderurlaub §29 TVöD'],
    [EntityClass.REHA]: ['Reha'],
    [EntityClass.KRANKHEIT_OHNE_AU]: ['Krankheit ohne Arbeitsunfähigkeitsbescheinigung'],
    [EntityClass.KRANKHEIT_MIT_AU]: ['Krankheit mit Arbeitsunfähigkeitsbescheinigung'],
    School: ['Schule'],
  },
  class: {
    ...filterTranslations.class,
    GroupFilterAspect: ['ist'],
    RoleFilterAspect: ['besitzt'],
    ClassBookingFilterAspect: ['besitzt'],
  },
  field: {
    suffix: ['Kostenstellensuffix'],
    _class: ['Typ'],
    schoolId: ['Schule'],
    name: ['Name'],
    nachname: ['Nachname'],
    parents: ['Übergeordnete Gruppen'],
    owner: ['Besitzer'],
    participants: ['Teilnehmer'],
    email: ['Email'],
    logo: ['Logo'],
    debitorenPrefix: ['Debitoren-Präfix'],
    diputatsstunden: ['Deputat-Stunden'],
    bundesland: ['Bundesland'],
    kostenstellePrefix: ['Kostenstelle-Präfix'],
    microsoftDomain: ['Microsoft Domain'],
    microsoftDomainForLogin: ['Microsoft Domain für Anmeldenamen'],
    rhythm: ['Rhythmus'],
    kostenstelleSuffix: ['Kostenstelle-Suffix'],
    schuelerNr: ['Schüler-Nr.'],
    abwesenheitsemail: ['Abwesenheitsemail'],
    debitorennummer: ['Debitor'],
    geschlecht: ['Geschlecht'],
    sorgeberechtigteKinder: ['Sorgeberechtigung für Kinder'],
    roles: ['Rollen'],
    profilDaten: ['Profildaten'],
    stammdaten: ['Stammdaten'],
    adresse: ['Adresse'],
    bankInfos: ['Bank-Infos'],
    ibanWrong: ['Falsche IBAN'],
    spende: ['Spende'],
    titel: ['Titel'],
    currentKlassenstufe: ['Aktuelle Klassenstufe'],
    selectedInterviewSlotID: ['Termin für das Bewerbungsgespräch'],
    geburtsDatum: ['Geburtsdatum'],
    geburtsdatum: ['Geburtsdatum Kind'],
    isSgSchool: ['Ist SG-Schule'],
    telefonNr: ['Telefonnummer'],
    vorname: ['Vorname'],
    active: ['Aktiv'],
    _id: ['ID'],
    amountInCents: ['Betrag in Cents'],
    gruppen: ['Gruppen'],
    schule: ['Schule'],
    microsoftGroupData: ['Microsoft Daten'],
    microsoftID: ['Microsoft ID'],
    mailNickname: ['Mail-Nickname'],
    createdInEntra: ['Erstellt in Entra'],
    description: ['Beschreibung'],
    secureGroup: ['Sicherheits Gruppe'],
    visibility: ['Sichtbarkeit'],
    contexts: ['Schule'], // yes not really correct but the context only interest the user if it is a school id
    mitarbeiterDaten: ['Mitarbeiterdaten'],
    anBeschaeftigung: ['Beschäftigung'],
    abrechnungsgruppe: ['Abrechnungsgruppe'],
    personalNr: ['Pers.'],
    hoechsterSchulAbschluss: ['Höchster Schulabschluss'],
    hoechsterBerufsAbschluss: ['Höchster Berufsabschluss'],
    steuerIdentNr: ['Steuer-Ident-Nr.'],
    streetAndNumber: ['Strasse und Hausnummer'],
    zip: ['PLZ'],
    city: ['Ort'],
    country: ['Land'],
    auslandsPlz: ['Auslands-PLZ'],
    geburtsLand: ['Geburtsland'],
    geburtsOrt: ['Geburtsort'],
    geburtsName: ['Geburtsname'],
    familienstand: ['Familienstand'],
    staatsangehoerigkeit: ['Staatsangehörigkeit'],
    verfuegbarkeit: ['Verfügbarkeit'],
    steuerklasse: ['Steuerklasse'],
    konfession: ['Konfession'],
    religion: ['Religion'],
    versicherungsStatus: ['Krankenversicherungsstatus'],
    rentenVersicherungsNr: ['Rentenversicherungsnummer'],
    krankenkassenID: ['Krankenkasse'],
    istPrivatVersichert: ['Privat versichert am 31.12.2002'],
    selbstverpflichtung: ['Selbstverpflichtungserklärung'],
    datenschutz: ['Datenschutzserklärung'],
    infektionsschutz: ['Infektionsschutz'],
    studentSozialversicherungspflicht: ['Sozialversicherungspflicht Student'],
    mitarbeiterInformation: ['Information für Mitarbeiter'],
    grad: ['Grad der Behinderung'],
    dienststelle: ['Dienststelle'],
    gueltigVon: ['Gueltig Von'],
    motivation: ['Motivation'],
    gueltigBis: ['Gueltig Bis'],
    priceInCents: ['Preis in Cent'],
    kennzeichnung: ['Aktenzeichen, Ausweisnummer oder Geschäftszeichen'],
    schwerbehinderungID: ['Nachweis der Schwerbehinderung'],
    legacyDebitorNumbers: ['Alte Debitorennummer'],
    nameAbbreviation: ['Lehrerkürzel'],
    microsoftUserData: ['Microsoft Daten'],
    schuelerDaten: ['Schülerdaten'],
    sorgeberechtigteEltern: ['Sorgeberechtigte Eltern'],
    spender: ['Spender'],
    spendenKinder: ['Spenden Kinder'],
    geschwister: ['Geschwister'],
    shareWithMicrosoft: ['Persönliche Daten mit Microsoft teilen'],
    manuallyChangedName: ['Name in Microsoft manuell geändert'],
    userPrincipalName: ['User Principal Name'],
    mail: ['Microsoft Mail'],
    otherMails: ['Microsoft Mail-Aliase'],
    manualMails: ['Zusätzliche Microsoft Mail-Adressen'],
    syncRejections: ['Von Entra abgelehnte Werte'],
    namenszusatz: ['Namenszusatz'],
    vorsatzWort: ['Vorsatzwort'],
    attentionLine: ['Anschriftenzusatz'],
    iban: ['IBAN'],
    kuerzel: ['Kürzel'],
    publicSchool: ['Im Anmeldeformular angezeigt'],
    buchungskonto: ['Buchungskonto'],
    kontoinhaber: ['Kontoinhaber'],
    nichtSepa: ['Nicht SEPA'],
    nichtSepaLand: ['Nicht SEPA Land'],
    nichtSepaKreditinstitut: ['Nicht SEPA Kreditinstitut'],
    nichtSepaOrt: ['Nicht SEPA Ort'],
    nichtSepaSWIFT: ['Nicht SEPA SWIFT'],
    nichtSepaIBAN: ['Nicht SEPA IBAN'],
    nichtSepaLaenderschluessel: ['Nicht SEPA Laenderschluessel'],
    betrag: ['Betrag'],
    zahlungsRythmus: ['Zahlungsrythmus'],
    startDatum: ['Startdatum'],
    endDatum: ['Enddatum'],
    lastschriftZugestimmt: ['Lastschrift zugestimmt'],
    heinNummer: ['Heinnummer'],
    externalUniqueID: ['Externe ID'],
    eingeladeneSorgeberechtigte: ['Eingeladene Sorgeberechtigte E-Mails'],
    eingeladeneSpender: ['Eingeladene Spender E-Mails'],
    lodasPersonalNr: ['Lodas Personal-Nr.'],
    altePersonalNr: ['Alte Personal-Nr.'],
    jobTicketKenntnis: ['Jobticket Kenntnis'],
    jobTicketBestaetigt: ['Jobticket Bestätigt'],
    jobTicketDatenweitergabe: ['Jobticket Datenweitergabe'],
    deutschlandTicketBestellt: ['Deutschland Ticket Bestellt'],
    jobTicketBestellDatum: ['Jobticket Bestell Datum'],
    jobTicketKuendigungsDatum: ['Jobticket Kündigungs Datum'],
    jobTicketExportiertAm: ['Jobticket Exportiert Am'],
    anInfos: ['Mitarbeiterinformationen'],
    anSteuerInfos: ['Steuerinformationen'],
    anSozialVersicherung: ['Sozialversicherung'],
    anAusbildung: ['Ausbildung'],
    anPrivatVersicherung: ['Privatversicherung'],
    anGeringfuegigeBeschaeftigung: ['Geringfügige Beschäftigung'],
    anSchwerbehinderung: ['Schwerbehinderung'],
    anDokumente: ['Dokumente'],
    anPersonalakte: ['Personalakte'],
    anEinverstaendnisErklaerungen: ['Einverstanden mit Erklärungen'],
    anVermoegenswirksameLeitungen: ['Vermoegenswirksame Leitungen'],
    contractApplyDate: ['Applizierungsdatum des Vertrages'],
    aufenthaltsgenehmigungID: ['Kopie Aufenthaltserlaubnis'],
    arbeitserlaubnisID: ['Kopie Arbeitserlaubnis'],
    firstName: ['Vorname'],
    schulwechselMotivation: ['Schulwechsel Grund'],
    lastName: ['Nachname'],
    birthday: ['Geburtsdatum'],
    placeofBirth: ['Geburtsort'],
    schoolType: ['Schulart'],
    zipSB: ['PLZ Sorgeberechtigte'],
    citySB: ['Ort Sorgeberechtigte'],
    firstNameSB: ['Vorname Sorgeberechtigte'],
    lastNameSB: ['Nachname Sorgeberechtigte'],
    countryOfBirth: ['Geburtsland'],
    klassenstufe: ['Klassenstufe'],
    lastGradeGerman: ['Letzte Note im Fach Deutsch'],
    lastGradeMath: ['Letzte Note im Fach Mathematik'],
    lastGradeSachunterricht: ['Letzte Note im Fach Sachunterricht'],
    potentialMartinusElementarySchoolID: ['Schule'],
    potentialMartinusElementarySchoolName: ['Name der anderen Schule'],
    lastPrimarySchool: ['Letzte Grundschule'],
    masernschutz: ['Nachweis Masernschutz'],
    familyLanguageIsGerman: ['Sprache zu Hause'],
    hasSiblingsAtMartinusSchools: ['Geschwister an einer Schule der Schulgesellschaft'],
    schoolyearsAfterElementary: ['Schulbesuchsjahre bis zum Ende der Grundschule'],
    fuehrungszeugnisID: ['Führungszeugnis'],
    fuehrungszeugnisAusstellung: ['Führungszeugnis Ausstellung'],
    masernimpfungID: ['Masernimpfung'],
    lebenslaufID: ['Lebenslauf'],
    personalbogenID: ['Personalbogen'],
    erklaerungStrafverfahrenID: ['Erklärung Strafverfahren'],
    activeBuchungen: ['Aktive Buchungen'],
    createdAt: ['Erstellt am'],
    userID: ['Benutzer-ID'],
    groupIDs: ['Gruppen IDs'],
    groups: ['Gruppen'],
    startDate: ['Startdatum'],
    endDate: ['Enddatum'],
    grade: ['Jahrgangsstufe'],
    classIdentifier: ['Klassenbezeichner'],
    buchungen: ['Alle Buchungen'],
    activeContract: ['Aktiver Vertrag'],
    agInfos: ['AG-Infos'],
    agSozialVersicherung: ['AG-Sozialversicherung'],
    agEingruppierung1: ['AG-Eingruppierung 1'],
    agEingruppierung2: ['AG-Eingruppierung 2'],
    justification: ['Begründung'],
    supplements: ['Nachträge'],
    erfahrungstufeAg1: ['Erfahrungstufe AG 1'],
    erfahrungstufeAg2: ['Erfahrungstufe AG 2'],
    hauptarbeitgeber: ['Hauptarbeitgeber'],
    appliedDate: ['Applizierungsdatum'],
    nachtragsNummer: ['Nachtragsnummer'],
    subNachtragsnummer: ['Sub-Nachtragsnummer'],
    unterzeichnungsdatum: ['Unterzeichnungsdatum'],
    einstellungsdatum: ['Einstellungsdatum'],
    gekuendigtZum: ['Gekündigt zum / Befristung'],
    alleDokumenteVorgelegt: ['Alle Dokumente vorgelegt'],
    urlaubsTage: ['Urlaubstage'],
    anstellungsform: ['Anstellungsform'],
    pauschalbesteuerungMiniJob: ['Pauschalbesteuerung Mini-Job'],
    dauerProbezeit: ['Dauer Probezeit'],
    besonderePersonengruppe: ['Besondere Personengruppe'],
    nebenabrede: ['Nebenabrede'],
    isGestellungsContract: ['Ist Gestellungsvertrag'],
    workingStudentChecked: ['Werksstudentenstatus überprüft'],
    kvAGZuschuss: ['KV-AG-Zuschuss'],
    pvAGZuschuss: ['PV-AG-Zuschuss'],
    pvGesamtbeitrag: ['PV-Gesamtbeitrag'],
    beschaeftigungsart: ['Beschäftigungsart'],
    altfallGleiter: ['Altfall-Gleiter'],
    rentner: ['Rentner'],
    beitragsgruppenschluesselKV: ['Beitragsgruppenschlüssel KV'],
    beitragsgruppenschluesselRV: ['Beitragsgruppenschlüssel RV'],
    beitragsgruppenschluesselAV: ['Beitragsgruppenschlüssel AV'],
    beitragsgruppenschluesselPV: ['Beitragsgruppenschlüssel PV'],
    applyMidijob: ['Midijob anwenden'],
    privatVersichert: ['Privat versichert'],
    krankentagegeld: ['Krankentagegeld'],
    mehrfachbeschaeftigung: ['Mehrfachbeschäftigung'],
    leiharbeitsverhaeltnis: ['Leiharbeitsverhältnis'],
    ergaenzungSV: ['Ergänzung SV'],
    geringfuegigeBeschaeftigung: ['Geringfügige Beschäftigung'],
    kostenstelle: ['Kostenstelle'],
    kostenstelleID: ['Kostenstelle ID'],
    prozentsatz: ['Prozentsatz'],
    taetigkeit: ['Tätigkeit'],
    taetigkeitsschluessel: ['Tätigkeitsschlüssel'],
    zeitarbeitsverhaeltnis: ['Zeitarbeitsverhältnis'],
    stellenbezeichnung: ['Stellenbezeichnung'],
    endeProbezeit: ['Ende Probezeit'],
    sachkontenzuordnung: ['Sachkontenzuordnung'],
    agVertragsInfos: ['AG-Vertragsinfos'],
    agLohnGehaltszahlungen: ['AG-Lohn- und Gehaltszahlungen'],
    agArbeitszeit: ['AG-Arbeitszeit'],
    paidWorkTime: ['Bezahlte Arbeitszeit'],
    totalWorkTime: ['Gesamte Arbeitszeit'],
    tarifgruppe: ['Tarifgruppe'],
    entgeltart: ['Entgeltart'],
    fiktivBeginnStufe1: ['Fiktiv Beginn Stufe 1'],
    manuelleErfahrungsstufe: ['Manuelle Erfahrungsstufe'],
    start: ['Start'],
    end: ['Ende'],
    sepaMandats: ['SEPA Mandate'],
    acceptedAt: ['Akzeptiert am'],
    acceptedPersonName: ['Akzeptiert von'],
    vertragsart: ['Vertragsart Vermögenswirksame Leistungen'],
    bookingsOfChildren: ['Alle Buchungen der Kinder'],
    activeBuchungenOfChildren: ['Aktive Buchungen der Kinder'],
    debitorNumber: ['Debitorennummer'],
    scope: ['Herkunft'],
    lastLogin: ['Letzter Login'],
    saldo: ['Saldo'],
    lakHoursUntilLastSchoolYear: ['LAK-Stunden bis Ende des letzten Schuljahres'],
    geburtsLandFullName: ['Geburtsland (Name)'],
    staatsangehoerigkeit2: ['Zweite Staatsangehörigkeit'],
    staatsangehoerigkeitFullName: ['Staatsangehörigkeit (Name)'],
    staatsangehoerigkeit2FullName: ['Zweite Staatsangehörigkeit (Name)'],
    district: ['Ortsteil'],
    wantedKlassenstufe: ['Beworbene Klassenstufe'],
    bewerbungsDate: ['Datum der Bewerbung'],
    zuzugsDate: ['Zuzugsdatum'],
    ablehnungGrund: ['Ablehnungsgrund'],
    participationReligion: ['Teilnahme am Religionsunterricht'],
    currentKlassenstufeAtBewerbungsDate: ['Aktuelle Klassenstufe zum Zeitpunkt der Bewerbung'],
    languageAtHomeIsGerman: ['Zuhause wird Deutsch gesprochen'],
    interestInNativeLanguageCourses: ['Interesse an herkunftssprachlichen Kursen'],
    interestInWholeDaySchooling: ['Interesse an Nachmittagsbetreuung'],
    internalNotes: ['Interne Notizen'],
    susBewerberStatus: ['Bewerbungsstatus'],
    updateDeadline: ['Aktualisierungsfrist'],
    hatKinder: ['Hat Kinder'],
    anzahlKinder: ['Anzahl Kinder'],
    hatAufenthaltserlaubnis: ['Benötigt Aufenthaltserlaubnis'],
    hatArbeitserlaubnis: ['Benötigt Arbeitserlaubnis'],
    gueltigAb: ['Gültig ab'],
    ausstellungsDatumArbeitserlaubnis: ['Ausstellungsdatum Arbeitserlaubnis'],
    kinder: ['Kinder'],
    vorsorgeaufwendungenID: ['Vorsorgeaufwendungen'],
    vermoegensLeistungenID: ['Vermögenswirksame Leistungen'],
    gesundheitszeugnisID: ['Gesundheitszeugnis'],
    infektionsschutzID: ['Infektionsschutzbelehrung'],
    datenschutzID: ['Datenschutzerklärung'],
    selbstversplichtungserklaerungID: ['Selbstverpflichtungserklärung'],
    zeugnisseIDs: ['Zeugnisse'],
    sonstigeIDs: ['Sonstige Dokumente'],
    arbeitsvertragIDs: ['Arbeitsverträge'],
    nachtragIDs: ['Nachträge'],
    studienbescheinigungsIDs: ['Studienbescheinigungen'],
    beschaeftigungsgenehmigungIDs: ['Beschäftigungsgenehmigungen'],
    steuerklassePartner: ['Steuerklasse des Ehegatten/Lebenspartners'],
    factor: ['Faktor'],
    kinderFreibetrag: ['Kinderfreibetrag'],
    konfessionPartner: ['Konfession des Ehegatten/Lebenspartners'],
    steuerfreibetraege: ['Steuerfreibeträge'],
    jahresFreibetrag: ['Jahresfreibetrag'],
    jahresHinzurechnungsbetrag: ['Jahreshinzurechnungsbetrag'],
    monatsFreibetrag: ['Monatsfreibetrag'],
    monatsHinzurechnungsbetrag: ['Monatshinzurechnungsbetrag'],
    krankenkassen: ['Krankenkassendaten'],
    rahmenNr: ['Rahmen-Nr.'],
    krankenkasse: ['Krankenkasse (Kurzname)'],
    bezeichnung: ['Bezeichnung'],
    ort: ['Ort'],
    betriebsnummer: ['Betriebsnummer'],
    letzteGesKrankenkasseID: ['Transitkrankenkasse'],
    anspruchKrankentageGeld: ['Anspruch auf Krankentagegeld'],
    krankenBeitrag: ['Priv. Krankenversicherungsbeitrag'],
    pflegenBeitrag: ['Priv. Pflegeversicherungsbeitrag'],
    arbeitgeberzuschussID: ['Arbeitgeberzuschuss'],
    isPrivatPflegeversichert: ['Privat pflegeversichert'],
    beitragsanteilBasisKrankenversicherung: ['Monatl. Beitragsanteil Basiskrankenversicherung'],
    geringfuegigeBeschaeftigungGewuenscht: ['Geringfügige Beschäftigung gewünscht'],
    befreiungRentenversicherungspflichtGewuenscht: ['Befreiung von der Rentenversicherungspflicht gewünscht'],
    pauschalbesteuerungGeringfuegig: ['Pauschalbesteuerung geringfügig'],
    pauschalbesteuerungGeringfuegigSonstige: ['Pauschalbesteuerung geringfügig (Sonstige)'],
    beschaeftigungslos: ['Bei der Agentur für Arbeit gemeldet'],
    beschaefitgungslosLeistungsbezug: ['Leistungsbezug der Agentur für Arbeit'],
    geringfuegigKrankenkasseBetriebsnummer: ['Betriebsnr. abweichender Krankenkasse'],
    krankenversicherung: ['Krankenversichert'],
    artKrankenversicherung: ['Art der Krankenversicherung'],
    beschaftigung: ['Bestehende Beschäftigungsverhältnisse'],
    beschaeftigungen: ['Bestehende Beschäftigungen'],
    beschaftigungsbeginn: ['Beschäftigungsbeginn'],
    arbeitgeberMitAdresse: ['Arbeitgeber mit Adresse'],
    entlohnungsArt: ['Entlohnungsart'],
    mitEigenanteilZurRv: ['Mit Eigenanteil zur RV'],
    lohn: ['Lohn'],
    arbeit: ['Beschäftigungsverhältnisse im laufenden Kalenderjahr'],
    arbeits: ['Beschäftigungen im laufenden Kalenderjahr'],
    beginBeschaftigungMeldung: ['Beginn'],
    endeBeschaftigungMeldung: ['Ende'],
    monatlichesArbeitsentgeltGroesserAls520Euro: ['Mehr als 520 € im Monat'],
    tatsachlicheArbeitstageInDiesemZeitraum: ['Arbeitstage im Zeitraum'],
    auslandsbeschaeftigung: ['Beschäftigungsverhältnisse im Ausland'],
    auslandbeschaeftigung: ['Beschäftigungen im Ausland'],
    beschaftigungsBeginn: ['Beschäftigungsbeginn'],
    beschaftigungsEnde: ['Beschäftigungsende'],
    beantrageBefreiungRentenversicherung: ['Befreiung der Rentenversicherung beantragt'],
    istVorhanden: ['Schwerbehinderung vorhanden'],
    employeeType: ['Arbeitnehmertyp'],
    personenGruppe: ['Personengruppe'],
    kreditorenNr: ['Kreditorennummer'],
    mandateReference: ['Mandatsreferenz'],
    billedOn: ['Abgerechnet am'],
    accepted: ['Akzeptiert'],
    billingLocked: ['Abrechnung gesperrt'],
    billingPosition: ['Abrechnungsposition'],
    erfahrungsstufeAg1: ['Erfahrungsstufe AG 1'],
    erfahrungsstufeAg2: ['Erfahrungsstufe AG 2'],
    kostenstelleProzentsaetze: ['Kostenstellen'],
    school: ['Schule'],
    monatlicheZahlungen: ['Monatliche Zahlungen'],
    lohnart: ['Lohnart'],
    lohnartNumber: ['Lohnart-Nummer'],
    monat: ['Monat'],
    jahr: ['Jahr'],
    maxDeputat: ['Max. Deputat'],
    zaehler: ['Geleistete Stunden'],
    stunden: ['Stunden'],
    ferienEinarbeiten: ['Ferien einarbeiten'],
    accountingNumber: ['Buchhaltungsmandant'],
    // accounting entries: the engine only labels them in its paraglide messages, which old data views and exports never read
    timestamp: ['Datum'],
    fiscalYear: ['Geschäftsjahr'],
    accountingCategory: ['Buchhaltungskategorie'],
    source: ['Quelle'],
    amountInMinorUnit: ['Betrag'],
    currency: ['Währung'],
    currencyFactor: ['Währungsfaktor'],
    direction: ['Soll/Haben'],
    account: ['Konto'],
    mandant: ['Mandant'],
    counterPartyAccount: ['Gegenkonto'],
    kostentraeger: ['Kostenträger'],
    transactionText: ['Buchungstext'],
    belegfeld1: ['Belegfeld 1'],
    processIdentifier: ['Vorgang'],
    referencesEntityIDs: ['Verknüpfte Objekte'],
    groupingID: ['Gruppierung'],
    tags: ['Tags'],
    schoolIDs: ['Schulen (IDs)'],
    schools: ['Schulen'],
    importError: ['Importfehler'],
    canBeDownloadedAsQuittung: ['Als Quittung herunterladbar'],
    returnOrder: ['Rücklastschrift'],
    tag: ['Landeskasse'],
    sourceFileID: ['Quelldatei (ID)'],
    rowIndex: ['Zeile'],
    csvIban: ['IBAN laut Datei'],
    csvKontoinhaber: ['Kontoinhaber laut Datei'],
    parseError: ['Lesefehler'],
    guid: ['Buchungs-GUID'],
    transactionID: ['Transaktions-ID'],
    mandatsID: ['Mandats-ID'],
    resolvedAt: ['Zuletzt zugeordnet'],
  },
  action_picker: {
    start: ['Start'],
    navigate: ['Navigieren'],
    back: ['Zurück'],
    execute: ['Ausführen'],
    close: ['Schließen'],
    nothing_found: ['Nichts gefunden'],
  },
  cms: {
    addEntry: ['Eintrag hinzufügen'],
  },
};

export const languages = [Language.GERMAN];
